// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer__3_VRr"};


//////////////////
// WEBPACK FOOTER
// ./components/footer/style.scss
// module id = R99g
// module chunks = 13